let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';

// Overrides to remove gridlines for crmUI
const GlobalStyle = createGlobalStyle(_t || (_t = _`
  div[data-test-crmui="true"] {
    td {
      border-left: none !important;
      border-right: none !important;
    }
    tr[data-test-id="crm-table-row"] {
      td:first-child {
        border-right: none !important;
      }
    }
  };

  div[data-test-id="framework-data-table-container"] {
    >div[class^="UIBox"]{
      &:has(div[data-test-id^="empty-state-FIRST_TIME_IN_APP"]) {
        border: none!important;
      };
    };
  }
`));
export default GlobalStyle;